/* eslint-disable @typescript-eslint/no-explicit-any */
import { PropsWithChildren, createContext } from "react";
import { useImmerReducer } from "use-immer";

// Constants
import { LS_ID, LS_TOKEN, LS_UUID } from "@constants/";

// Utils
import { getItem, removeItem, setItem } from "@utils/";

import { EActionAuthType, IAction, IInitialState, IState } from "@interfaces/";

const token: string | null = getItem(LS_TOKEN) ?? null;
const id: string | null = getItem(LS_ID) ?? null;
const uuid: string | null = getItem(LS_UUID) ?? null;

const initialState: IInitialState = {
  token: token !== null ? token : null,
  id: id !== null ? id : null,
  uuid: uuid !== null ? uuid : null,
  isAuthenticated: token !== null,
  dispatch: () => {},
};

function reducer(state: IState, action: IAction): IState {
  switch (action.type) {
    case EActionAuthType.LOGIN:
      setItem(LS_TOKEN, action.payload.token);
      setItem(LS_ID, (action.payload as any).data?.id);
      setItem(LS_UUID, (action.payload as any).data?.uuid);
      return {
        isAuthenticated: true,
        token: action.payload.token,
        id: (action.payload as any).data?.id,
        uuid: (action.payload as any).data?.uuid,
      };
    case EActionAuthType.SIGNUP:
      setItem(LS_TOKEN, action.payload.token);
      setItem(LS_ID, (action.payload as any).data?.id);
      setItem(LS_UUID, (action.payload as any).data?.uuid);
      return {
        isAuthenticated: true,
        token: action.payload.token,
        id: (action.payload as any).data?.id,
        uuid: (action.payload as any).data?.uuid,
      };
    case EActionAuthType.LOGOUT:
      removeItem(LS_TOKEN);
      removeItem(LS_ID);
      return {
        isAuthenticated: false,
        token: null,
        id: null,
        uuid: null,
      };
    default:
      return state;
  }
}

export const AuthContext = createContext(initialState);

function AuthProvider({ children }: PropsWithChildren) {
  const [state, dispatch] = useImmerReducer<IState, IAction>(reducer, initialState);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: state.isAuthenticated,
        token: state.token,
        id: state.id,
        uuid: state.uuid,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthProvider };
